var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResultWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60.3496,
    r: 59.5,
    fill: "#FF6301",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9019 37.3496C59.0566 35.3496 61.9434 35.3496 63.0981 37.3496L83.8827 73.3496C85.0374 75.3496 83.594 77.8496 81.2846 77.8496H39.7154C37.406 77.8496 35.9626 75.3496 37.1173 73.3496L57.9019 37.3496Z",
    fill: "#FF6301"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4363 63.6696V53.8496H61.5363V63.6696H59.4363ZM60.4963 68.1296C60.0297 68.1296 59.6363 67.9763 59.3163 67.6696C59.0097 67.3629 58.8563 66.9696 58.8563 66.4896C58.8563 66.0096 59.0097 65.6229 59.3163 65.3296C59.6363 65.0229 60.0297 64.8696 60.4963 64.8696C60.963 64.8696 61.3497 65.0229 61.6563 65.3296C61.9763 65.6363 62.1363 66.0229 62.1363 66.4896C62.1363 66.9696 61.9763 67.3629 61.6563 67.6696C61.3497 67.9763 60.963 68.1296 60.4963 68.1296Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultWarning);
export default __webpack_public_path__ + "static/media/result-warning.242ad150d509fd93cfd7e7ad3051aff2.svg";
export { ForwardRef as ReactComponent };